import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import * as Notifications from 'expo-notifications'
import keys from './shared/keys'

export function useResetBadgeCount() {
  const { server } = useServer()
  const client = useQueryClient()
  return useMutation({
    mutationKey: keys.badge(),
    mutationFn: resetAppBadgeCount,
    onSuccess: async () => {
      await client.invalidateQueries({ queryKey: keys.badge() })
      await Notifications.setBadgeCountAsync(0)
    },
  })

  async function resetAppBadgeCount() {
    const response = await server.delete('/v2/users/me/badge')
    return response
  }
}
